// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.placeholder-item {
    border-radius: 4px;
}
.loading_container {
    position: relative;
    overflow: hidden;
    background-color: #eee7e7;
    border-radius: 2px;
}

.loading_title {
    width: 100%;
}
.loading_container::before {
    content: '';
    display: block;
    position: absolute;
    left: -150px;
    top: 0;
    height: 100%;
    width: 150px;
    background: linear-gradient(to right, transparent 0%, #ddcfcf 50%, transparent 100%);
    animation: load 1s cubic-bezier(0.4, 0.0, 0.2, 1) infinite;
}
/* Grid layout */
.loading_box {
    margin: 20px;
    border-radius: 10px;
    padding: 20px;
}
.loading_sec-1 {
    grid-area: sec-1;
}
.loading_sec-2 {
    grid-area: sec-2;
    display: grid;
    grid-template-columns: 1fr 1fr;
}
.loading_sec-3 {
    grid-area: sec-3;
}
.loading_sec-4 {
    grid-area: sec-4;
    position: relative;
}
.loading_sec-5 {
    grid-area: sec-5;
}
.loading_sec-6 {
    grid-area: sec-6;
}
.loading_sec-7 {
    grid-area: sec-7;
}
.loading_grid_container {
    height: 1800px;
    display: grid;
    grid-template-columns: 36vw 36vw 27vw;
    grid-template-rows: auto;
    grid-template-areas:
    "sec-1 sec-2 sec-3"
    "sec-4 sec-4 sec-3"
    "sec-5 sec-5 sec-6"
    "sec-7 sec-7 sec-7";
}
.loading_chart {
    display: flex;
    position: absolute;
    left: 20px;
    bottom: 20px;
}
@keyframes load {
    from {
        left: -150px;
    }
    to   {
        left: 100%;
    }
}
@media (max-width: 1150px) {
    .loading_grid_container {
        height: 2800px;
        display: grid;
        grid-template-columns: 100vw;
        grid-template-rows: auto;
        grid-template-areas:
    "sec-1"
    "sec-2"
    "sec-3"
    "sec-4"
    "sec-5"
    "sec-6"
    "sec-7";
    }
}

.table_loading {
    height: 700px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/LoadingPlaceholders/LoadingPlaceholders.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,oFAAoF;IACpF,0DAA0D;AAC9D;AACA,gBAAgB;AAChB;IACI,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,aAAa;IACb,qCAAqC;IACrC,wBAAwB;IACxB;;;;uBAImB;AACvB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;AACA;IACI;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI;QACI,cAAc;QACd,aAAa;QACb,4BAA4B;QAC5B,wBAAwB;QACxB;;;;;;;WAOG;IACP;AACJ;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".placeholder-item {\n    border-radius: 4px;\n}\n.loading_container {\n    position: relative;\n    overflow: hidden;\n    background-color: #eee7e7;\n    border-radius: 2px;\n}\n\n.loading_title {\n    width: 100%;\n}\n.loading_container::before {\n    content: '';\n    display: block;\n    position: absolute;\n    left: -150px;\n    top: 0;\n    height: 100%;\n    width: 150px;\n    background: linear-gradient(to right, transparent 0%, #ddcfcf 50%, transparent 100%);\n    animation: load 1s cubic-bezier(0.4, 0.0, 0.2, 1) infinite;\n}\n/* Grid layout */\n.loading_box {\n    margin: 20px;\n    border-radius: 10px;\n    padding: 20px;\n}\n.loading_sec-1 {\n    grid-area: sec-1;\n}\n.loading_sec-2 {\n    grid-area: sec-2;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n}\n.loading_sec-3 {\n    grid-area: sec-3;\n}\n.loading_sec-4 {\n    grid-area: sec-4;\n    position: relative;\n}\n.loading_sec-5 {\n    grid-area: sec-5;\n}\n.loading_sec-6 {\n    grid-area: sec-6;\n}\n.loading_sec-7 {\n    grid-area: sec-7;\n}\n.loading_grid_container {\n    height: 1800px;\n    display: grid;\n    grid-template-columns: 36vw 36vw 27vw;\n    grid-template-rows: auto;\n    grid-template-areas:\n    \"sec-1 sec-2 sec-3\"\n    \"sec-4 sec-4 sec-3\"\n    \"sec-5 sec-5 sec-6\"\n    \"sec-7 sec-7 sec-7\";\n}\n.loading_chart {\n    display: flex;\n    position: absolute;\n    left: 20px;\n    bottom: 20px;\n}\n@keyframes load {\n    from {\n        left: -150px;\n    }\n    to   {\n        left: 100%;\n    }\n}\n@media (max-width: 1150px) {\n    .loading_grid_container {\n        height: 2800px;\n        display: grid;\n        grid-template-columns: 100vw;\n        grid-template-rows: auto;\n        grid-template-areas:\n    \"sec-1\"\n    \"sec-2\"\n    \"sec-3\"\n    \"sec-4\"\n    \"sec-5\"\n    \"sec-6\"\n    \"sec-7\";\n    }\n}\n\n.table_loading {\n    height: 700px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
